//import EventEmitter from "events";

//export const uploadFileEmitter = new EventEmitter();

import mitt from "mitt";

export const uploadFileEmitter = mitt();
